import axios from "axios";
import store from "@/store";
import i18n from "@/core/i18n";
import router from "@/core/router";
import toast from "@/core/toast";

const httpClient = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    withCredentials: false,
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    }
});

httpClient.interceptors.request.use(
    config => {
        store.dispatch("loader/pending");

        const url = new URL(config.url, config.baseURL);

        // maybe we can add here more elegant way, but let it be later
        let pathname = url.pathname;
        if (store.getters["auth/context"]) {
            pathname = url.pathname.replace(
                ":app_id",
                store.getters["auth/context"]?.app_id
            );
            pathname = url.pathname.replace(
                ":app_uuid",
                store.getters["auth/context"]?.app_uuid
            );

            if (config.withoutUuidHeader !== true) {
                config.headers.common["X-App-Uuid"] =
                    store.getters["auth/context"]?.app_uuid;
            }

            if (store.getters["auth/context"].campaign_id)
                config.headers.common["X-Campaign-ID"] =
                    store.getters["auth/context"].campaign_id;

            if (store.getters["auth/context"].booking_reference)
                config.headers.common["X-Booking-Reference"] =
                    store.getters["auth/context"].booking_reference;

            config.headers.Authorization = `Bearer ${store.getters["auth/context"]?.token}`;
        }

        return {
            ...config,
            baseURL: `${url.protocol}//${url.host}`,
            url: pathname
        };
    },
    error => {
        store.dispatch("loader/done");

        return Promise.reject(error);
    }
);

httpClient.interceptors.response.use(
    response => {
        store.dispatch("loader/done");

        return Promise.resolve(response.data);
    },
    error => {
        store.dispatch("loader/done");

        if (
            error.response.status === 401 &&
            router.currentRoute.name !== "Login"
        ) {
            router.push({ name: "Login" });
        } else if (error.response.status > 401 && error.response.status < 500) {
            // pass this, this error should be showed for user, with description
        } else if (error.response.status > 499 && error.response.status < 600) {
            console.error("Server error: ", error.response);
            router.push({ name: "Server Error" });
        } else if (error.code === "ECONNABORTED") {
            toast.warning(i18n.t("errors.timeout_error"));
        } else {
            console.error("Unknown error: ", error.response);
            router.push({ name: "Server Error" });
        }

        return Promise.reject(error);
    }
);

export default httpClient;
